// How providers appear in AI settings: brand names, except the generic OpenAI-compatible API, which is translated.
// Their default models come from the server (settings.providers).
export const AI_PROVIDERS = {
  openai: { label: 'OpenAI', keyUrl: 'https://platform.openai.com/api-keys' },
  anthropic: {
    label: 'Anthropic (Claude)',
    keyUrl: 'https://console.anthropic.com/settings/keys',
  },
  gemini: {
    label: 'Google Gemini',
    keyUrl: 'https://aistudio.google.com/apikey',
  },
  openrouter: {
    label: 'OpenRouter',
    keyUrl: 'https://openrouter.ai/settings/keys',
  },
  ollama: {
    label: 'Ollama',
    noKey: true,
    basePlaceholder: 'http://localhost:11434/v1',
  },
  openai_compatible: {
    basePlaceholder: 'https://api.example.com/v1',
  },
};

export const needsApiBase = provider =>
  ['ollama', 'openai_compatible'].includes(provider);

export const providerLabel = (provider, t) =>
  provider === 'openai_compatible'
    ? t('LOCO.AI.SETTINGS.OPENAI_COMPATIBLE')
    : AI_PROVIDERS[provider]?.label || provider;
